
import { Pagination, PaginationProps } from "@mui/material";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import React from "react";

const PaginationCDV = ({
    variant = "outlined",
    shape = "rounded",
    onChange,
    ...props
}: PaginationProps) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
        onChange?.(_event, page);
        sessionStorage.setItem('paginated-scrollY', String(window.scrollY));
        const params = new URLSearchParams((searchParams?.toString() ?? ""));
        params.set('page', String(page));
        router.push(`${pathname}?${params.toString()}`, {
            scroll: false, 
        });
    };
    return (
        <Pagination
            variant={variant}
            shape={shape}
            onChange={handlePageChange}
            {...props}
        />
    )
}
export default PaginationCDV;